var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"channer_tab2"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"content_tab"},[_c('orgTree')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }